import { render } from "./Divider.vue?vue&type=template&id=3cdeb6fa&scoped=true&ts=true"
import script from "./Divider.vue?vue&type=script&lang=ts"
export * from "./Divider.vue?vue&type=script&lang=ts"

import "./Divider.vue?vue&type=style&index=0&id=3cdeb6fa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cdeb6fa"]])

export default __exports__